export enum ETipoAcessorio {
  NAO_SEI = 'NaoSei'
}
